import ApiInstance from "../api/ApiInstance";

/** Download an authenticated CSV endpoint as a file (cookie auth → fetch as
 *  blob, then a temporary <a download>). */
export async function downloadCsv(path: string, fallbackFilename: string): Promise<void> {
  const res = await ApiInstance.getApi().get(path, { responseType: "blob" });
  const disposition = String(res.headers?.["content-disposition"] || "");
  const filename = /filename="([^"]+)"/.exec(disposition)?.[1] || fallbackFilename;
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
